<template>
  <section
    class="section-promotions"
    :class="is_food ? 'pt-3' : ''"
    v-if="!isLoadingPromotions"
  >
    <div class="container">
      <header class="section-header mb-2">
        <!-- <div class="section-header-title"> -->
          <!-- {{ is_food ? "Food Offers" : "Promos &amp; Offers" }} -->
          <!-- <img
            src="@/assets/img/gif/Mascots-babycorn-small.gif"
            height="63"
            width="50"
            alt
            class="home-gif-image"
          /> -->
        <!-- </div> -->
        <router-link
          v-if="!isLoadingPromotions && promotions.length > 1"
          class="d-none d-md-block"
          to="/offers-and-promotions"
          >View all >>></router-link
        >
        <router-link
          v-if="!isLoadingPromotions && promotions.length > 0"
          class="d-md-none mobile-seeAll-btn"
          to="/offers-and-promotions"
          >See All</router-link
        >
      </header>

      <div class="row offersAndPromotionsBox">
        <component-content-loader v-if="isLoadingPromotions" />
        <div
          v-if="!isLoadingPromotions && promotions.length > 0"
          v-for="(PromotionItems, PromotionIndex) in promotions"
          :key="PromotionIndex + '_Promos'"
          class="mb-3 mb-md-0 box"
          :class="
            is_food
              ? 'col-12 px-0'
              : 'col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'
          "
        >
          <div class="row mx-0 shadow rounded bg-dark-2">
            <div class="px-0" :class="is_food ? 'col-12' : 'col-md-4'">
              <img
                :src="IMAGE_URL + PromotionItems.image_path"
                class="place-img"
                alt=""
              />
              <!-- @/assets/img/placeHolder.png -->
            </div>
            <div class="py-3" :class="is_food ? 'col-12' : 'col-md-8'">
              <div class="text-right mb-3">
                <img :src="IMAGE_URL + PromotionItems.promo_partner" alt="" />
                <!-- @/assets/img/Axis_Bank_logo_logotype 1.png -->
              </div>
              <h4 class="add-title">{{ PromotionItems.promo_title }}</h4>
              <p class="add-text">
                {{ PromotionItems.promo_description }}
              </p>
              <p class="add-small-txt">
                Valid till {{ PromotionItems.promo_expiry | dateparse }}
              </p>
              <p class="tnc-txt">{{ PromotionItems.promo_required || "" }}</p>
            </div>
          </div>
        </div>
        <!-- <empty-state
          v-if="!isLoadingPromotions && promotions.length === 0"
          isClass="border-0"
          :emptyMessage="`No Promos and Offers Found`"
          :isNeedTopSpace="false"
        /> -->
        <!-- <div
          class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 mb-md-0 box"
        >
          <div class="row mx-0 shadow rounded">
            <div class="col-md-4 px-0 pr-md-3">
              <img
                src="@/assets/img/placeHolder.png"
                class="place-img"
                alt=""
              />
            </div>
            <div class="col-md-8 py-3">
              <div class="text-right mb-3">
                <img src="@/assets/img/Axis_Bank_logo_logotype 1.png" alt="" />
              </div>
              <h4 class="add-title">Axis Bank platinum credit card offer</h4>
              <p class="add-text">
                50% off upto ₹100 on your first transaction*
              </p>
              <p class="add-small-txt">Valid till 28 Feb, 2020</p>
              <p class="tnc-txt">* Transaction must be greater than ₹200</p>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
import { IMAGEURL } from "@/config";
import PromosandOffersService from "@/apiServices/PromosandOffersService";

export default {
  props: {},
  data() {
    return {
      IMAGE_URL: IMAGEURL,
      is_food: null,
      isLoadingPromotions: false,
      promotions: []
    };
  },
  computed: {},
  beforeMount() {
    if (
      this.$route.name === "Food And Drinks" ||
      this.$route.name === "Food and Drinks Checkout"
    ) {
      this.is_food = true;
      this.getPromotionsAndOffers({ is_food: true });
    } else {
      this.is_food = false;
      this.getPromotionsAndOffers({ is_food: false });
    }
  },
  methods: {
    async getPromotionsAndOffers({ is_food }) {
      // let loader = Vue.$loading.show();
      try {
        this.isLoadingPromotions = true;
        let food = is_food ? true : false;
        const response = await PromosandOffersService.GetPromosAndOffers({
          food
        });
        const { data } = response;
        if (data && data.status) {
          this.promotions = data.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        setTimeout(() => (this.isLoadingPromotions = false), 500);
      }
    }
  }
};
</script>
<style>
.section-promotions {
  padding-top: 30px;
  padding-bottom: 75px;
}

.img-promo {
  max-width: 100%;
  border: 1px solid var(--light);
  overflow: hidden;
  border-radius: 5px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/partials/promotionsAndOffers.vue